import script from "./Catalogs.vue?vue&type=script&setup=true&lang=js"
export * from "./Catalogs.vue?vue&type=script&setup=true&lang=js"

import "./Catalogs.vue?vue&type=style&index=0&id=473a3b7a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-473a3b7a"]])

export default __exports__